import isLoginAccountStore from "../store/isLoginAccount";
import loginAccountStore from "../store/isLoginAccount";
import isUpdateCookieStore from "../store/isUpdateCookie";



// Custom hook để sử dụng và cập nhật cấu hình player
const useIsUpdateCookie = () => {
    const isUpdateCookie = isUpdateCookieStore((state) => state.isUpdateCookie);
    const setIsUpdateCookie = isUpdateCookieStore((state) => state.setIsUpdateCookie);

    // Trả về thông tin của player đó và các hàm cập nhật
    return {
        isUpdateCookie,
        setIsUpdateCookie
    };
};

export default useIsUpdateCookie;
